// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['react', '/www/hola/pub/ui/use_scroll_by_hash.ts',
    '/www/hola/pub/context.js', '/www/hola/pub/util.js',
    '/www/hola/pub/support_lib.js',
    'react-router-dom',],
    (React, {use_scroll_by_hash}, context, www_util, support_lib,
    RRD)=>
{
const E = {};
const {App_context} = context;
const {useState, useContext, useEffect, Fragment} = React;
const {Link} = RRD;

const faq_items = {
    'ios-cancel': <p>
      Cancellations are done via the App Store application.
      See <a href="https://support.apple.com/en-il/HT202039">Apple's
      instructions</a>.
      <br/>
      Please note that In-app purchases that were already made are
      non-refundable due to Apple's terms of service.
    </p>,
    'ios-pay': <p>
      Payment is done using the built in iTunes In-App Purchase.</p>,
    'ios-dup_charge': <p>
      You might have subscribed on two different platforms. The Hola
      service is provided for each platform individually. Thus, if you
      registered on two platforms there will be two payments.
      <br/>
      Otherwise, for refund related claims, you should contact Apple Support.
      However; if there was a problem with the subscription duration, then
      please please contact our{' '}
      <a href="/premium_support">support team</a>.{' '}
      You must attach to your email both the iTunes invoice, and the mail you
      used to register to Hola.
    </p>,
    'ios-still_free': <Fragment>
      <p>
        If you purchased a subscription and you are still not a Premium user,
        please make sure that your payment has been successfully authorized.
        <br/>
        If your payment is successfully authorized and you are still not a
        Premium user, please try the following:
      </p>
      <ul>
        <li>
          Sign out from your account on Hola's App, close the background
          Hola App, and then launch it again, and try to log in again.
        </li>
        <li>
          Make sure the account you are trying to use is the same account
          you registered with.
          <br/>
          <strong>Please note: </strong>The Hola service is provided for
          each platform individually. If you have an account on one
          platform, it will not work on another platform, therefore; you
          need to buy another account if you want to use another platform.
        </li>
        <li>
          For the rest of the issues, contact
          our <a href="/premium_support">support team</a>.
        </li>
      </ul>
    </Fragment>,
    'ios-stop': <p>
      Premium accounts which were subscribed using iOS devices are not
      automatically renewed at the end of the subscription period.
    </p>,
    'ios-multi_devices': <p>
      The Hola service is provided for each platform individually. If you
      have a subscription on one platform, it will not work on another
      platform, therefore; you need to buy another subscription if you want
      to use Hola on an extra platform.
    </p>,
    'ios-social': <p>Choose the prefered social network after you
      click "Sign up" on the top right of the page.</p>,
    'android-cancel': <p>
      To uninstall Hola, go to Google Play, search for Hola PLUS Proxy,
      click <strong>cancel</strong> payments to stop the automatic payments
      to Hola. Then uninstall the App.<br/>
      Check <a href="https://support.google.com/googleplay/answer/7018481">
        Google Play subscription cancellation support</a> for more
      information.
    </p>,
    'android-pay': <p>Your payment method on Google Play.</p>,
    'android-dup_charge': <Fragment>
      <p>In case you saw two payments on your payment method, please consider
        the following:</p>
      <ul>
        <li>
          You might have subscribed on two different platforms. The Hola
          service is provided for each platform individually. Thus, if you
          registered on two platforms there will be two payments.
        </li>
        <li>
          If you registered on one platform only, but still you see two
          payments, please contact
          our <a href="/premium_support">support team</a>.
        </li>
      </ul>
    </Fragment>,
    'android-still_free': <Fragment>
      <p>
        If you purchased a subscription and you are still not a Premium user,
        please make sure that your payment has been successfully authorized.
        <br/>
        If your payment is successfully authorized and you are still not a
        Premium user, please try the following:
      </p>
      <ul>
        <li>
          Sign out from your account on Hola's App, close the background
          Hola App, and then launch it again, and try to log in again.
        </li>
        <li>
          Make sure the account you are trying to use is the same account
          you registered with.<br/>
          <strong>Please note: </strong>The Hola service is provided for
          each platform individually. If you have an account on one
          platform, it will not work on another platform, therefore; you
          need to buy another account if you want to use another platform.
        </li>
        <li>
          For the rest of the issues, contact
          our <a href="/premium_support">support team</a>.
        </li>
      </ul>
    </Fragment>,
    'android-stop': <p>
      Go to Google Play, search for Hola PLUS Proxy,
      click <strong>cancel</strong> payments.
    </p>,
    'android-multi_devices': <p>
      The Hola service is provided for each platform individually. If you
      have a subscription on one platform, it will not work on another
      platform, therefore; you need to buy another subscription if you want
      to use Hola on an extra platform.
    </p>,
    'android-social': <p>Choose the prefered social network after you
      click "Sign up" on the top right of the page.</p>,
    'pc-cancel': <p>To cancel your account, go to <Link to="/cp">your account
      page</Link>.</p>,
    'pc-pay': <p>
      Using major credit cards or PayPal if you sign up on desktop - or
      using iTunes/Google play if you sign up on mobile.
    </p>,
    'pc-dup_charge': <Fragment>
      <p>In case you saw two payments on your payment method, please consider
        the following:</p>
      <ul>
        <li>
          You might have subscribed on two different platforms. The Hola
          service is provided for each platform individually. Thus, if you
          registered on two platforms there will be two payments.
        </li>
        <li>
          If you registered on one platform only, but still you see two
          payments, please contact
          our <a href="/premium_support">support team</a>.
        </li>
      </ul>
    </Fragment>,
    'pc-still_free': <Fragment>
      <p>
        If you purchased a subscription and you are still not a Premium user,
        please make sure that your payment has been successfully authorized.
        <br/>
        If your payment is successfully authorized and you are still not a
        Premium user, please try the following:
      </p>
      <ul>
        <li>
          Sign out from your Hola's account, and try to log in again.
        </li>
        <li>
          Make sure the account you are trying to use is the same account
          you registered with.
          <br/>
          <strong>Please note:</strong> The Hola service is provided for
          each platform individually. If you have an account on one
          platform, it will not work on another platform, therefore; you
          need to buy another account if you want to use another platform.
        </li>
        <li>
          For the rest of the issues, contact
          our <a href="/premium_support">support team</a>.
        </li>
      </ul>
    </Fragment>,
    'pc-multi_devices': <p>
      The Hola service is provided for each platform individually. If you
      have a subscription on one platform, it will not work on another
      platform, therefore; you need to buy another subscription if you want
      to use Hola on an extra platform.
    </p>,
    'pc-social': <p>Choose the prefered social network after you
      click "Sign up" on the top right of the page.</p>,
    'refund-policy': <Fragment>
      <p>Hola offers a suite of services, including a free product, with
        restrictions. In order to have unlimited online access, Hola's
        Premium product is the one for you. Should you want to cancel your
        subscription to Hola Premium, you can do so at any time.</p>
      <p>Once your account passes its expiration date, your subscription
        will be automatically renewed. If you have canceled the auto-renewal,
        you will need to resubscribe to our services to continue using them.
        Sometimes we have to state the obvious :)</p>
      <p>Your satisfaction is of course important to us. If you've not
        used Hola Premium, at all, for up to 14 days after purchase,
        you will be eligible for a refund.</p>
      <p>If you've used Hola Premium, and you don't want Premium anymore,
        you can cancel  and keep what's left of what you've paid for. You'll
        remain Premium until your next payment is due - which is when your
        cancellation will kick in.</p>
      <p>Here are our instructions on how
        to <a href="/support/billing#cancel_recurring">cancel a recurring
        subscription</a>.</p>
      <p>While our policy allows customers to use Hola risk-free, we must 
        also protect ourselves from fraud. Therefore, we reserve the right,
        at our sole discretion, to limit or deny refund requests.</p>
      <p>iOS payments are processed directly through Apple (instead of Hola),
        hence, we are unable to offer refunds for in-app purchases made with
        your Apple account. More information can be found in Apple's refund
        policy: <a href="https://support.apple.com/HT204084"
        >https://support.apple.com/HT204084</a></p>
    </Fragment>,
};

E.Root = function Faq(props){
    const {user} = useContext(App_context);
    const [q, set_q] = useState('');
    useEffect(()=>{
        www_util.perr_www_visit({id: 'www_faq_billing_visit', user});
    }, []);
    use_scroll_by_hash();
    return <div className="hola_faq">
        <support_lib.Search q={q} show_results={false}
          on_change={ev=>set_q(ev.target.value)}
          on_clear={()=>set_q('')}/>
        <support_lib.Faq_page q={q} content={faq_items}
          entries={support_lib.faq_billing_entries}/>
    </div>;
};

return E;
});
